import { Directive, EventEmitter, HostBinding, Input, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ContextMenuService } from 'src/app/services/context-menu.service';

@Directive({
  selector: '[appInferredHover]',
  standalone: true,
})
export class InferredHoverDirective implements OnDestroy {
  contextSub: Subscription;
  @Input() appInferredHover: string;
  @Output() onInferredHoverChange = new EventEmitter();
  @HostBinding('class') elementClass: string;

  constructor(private contextService: ContextMenuService) {
    this.contextSub = this.contextService.onContextOpen.subscribe(event => {
      if (!this.appInferredHover) return;
      if (!event) return;

      const oldVal = this.elementClass || '';

      if ('contextHoverIdentifier' in event && event.contextHoverIdentifier === this.appInferredHover)
        this.elementClass = 'inferred-hover';
      else this.elementClass = '';

      if (oldVal !== this.elementClass) {
        this.onInferredHoverChange.emit(this.elementClass === 'inferred-hover');
      }
    });
  }

  ngOnDestroy(): void {
    this.contextSub.unsubscribe();
  }
}
